<template>
    <div>
        <div class="loading" v-if="loading_state">
            <p class="">loading...</p>
        </div>

        <div v-else>

            <div v-if="hasPayoutBeenInitiated">
                <div class="card border-0 shadow-sm">
                    <div class="card-body">
                        <div class="" v-if="oa_payout_info != null">
                            <div class="mb-4">
                                <p class="h6">Payout has already been initiated</p>

                                <p class=" small"> Selected Recipient(s): </p>
                            </div>

                            <div class="text-center pb-3" v-if="oa_payout_info != null">
                                <table class="table table-responsive">
                                    <thead>
                                            <!-- <tr class="">
                                                <th scope="col">#</th>
                                                <th scope="col"></th>
                                                <th scope="col"> </th>
                                                <th scope="col" style="width: 500px;"> </th>
                                                <th scope="col" v-if="pool.payout_rule == 'majority-vote'">Payout Vote</th>
                                            </tr> -->
                                    </thead>
                                    <tbody>
                                        
                                        <tr v-for="(payout_info, index) in oa_payout_info" :key="index">
                                            <div class="">

                                                <td class="">
                                                        <div class="avatar-container">
                                                            <img src="@/assets/avatar-purple.png" class="avatar" alt="avatar" style="height:40px; width: 40px;">
                                                        </div>

                                                </td>
                                                <td class="" style="min-width: 250px">
                                                    <div class="d-flex justify-content-start">
                                                        <p class="my-0 mr-3 h6">
                                                            {{ payout_info.profile.lastname}} {{ payout_info.profile.firstname }}
                                                        </p>

                                                    </div>
                                                </td>
                                                <td class=""> 
                                                    <div>
                                                        <p class="my-0 h6 text-success font-weight-bold"> &#8358;{{ payout_info.amount | moneyformat }}</p>
                                                    </div>
                                                </td>
                                            </div>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div class="text-center pb-3" v-else>
                                <p><span class="fa fa-exclamation-circle"></span> No recipients has been added for payout</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="card border-0 shadow-sm mb-3" v-if="pool != null && contributors != null">
                    <div class="card-body card-body-radio d-flex flex-column mb-3">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" id="account_type" value="single" v-model="form.payout_type">
                            <label class="custom-control-label" for="account_type">
                                <div class="ml-3">
                                    <h6 class="m-0 p-0 font-weight-bold">Single Payout </h6>
                                    <small class="m-0 p-0 text-muted">
                                        Withdraw all funds to your account or payout to a member of the pool
                                    </small>
                                </div>
                            </label>
                        </div>

                        <div class="ml-4 pl-3 my-2 single-select" :class="{ 'd-none': isMultiple, '': isSingle }">
                            <form @submit.prevent="payoutContribution()">
                                <div class="col-lg-6 p-0">

                                    <div class="d-flex align-items-center">
                                        <select name="" id="" class="form-control my-2" v-model="payees" value="multiple" @change="showSinglePayoutMessage($event)" required>
                                            <option value="0" selected disabled>Select Payout Recipient</option>
                                            <option 
                                                v-for="(contributor, index) in contributors" 
                                                :value="contributor.account_id" 
                                                :key="index">
                                                {{ contributor.account.profile.firstname }} {{ contributor.account.profile.lastname }}
                                            </option>
                                        </select>
                                    </div>

                                    <p class="small font-weight-bold" v-show="singlePayoutSelected">
                                        The complete sum of &#8358;{{ pool.contributed_amount | moneyformat }} would be payed out to this member.                               
                                    </p>
                                </div>
                                <div class="">
                                    <div class="form-group">
                                        <div class="d-flex mt-4 w-100">
                                            <div class="d-none d-md-block">
                                                <button type="submit" class="btn btn-custom-sm ml-auto">Payout</button>
                                            </div>
                                        </div>
                                        <div class="mt-2">
                                            <div class="d-md-none d-sm-block">
                                                <button type="submit" class="btn btn-custom btn-block ml-auto">Payout</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </form>

                        </div>
                    </div>
                </div>

                <div class="card border-0 shadow-sm" v-if="contributors != null">

                    <div class="card-body d-flex flex-column card-body-radio mb-3">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" id="account_business" value="multiple" v-model="form.payout_type">
                            <label class="custom-control-label" for="account_business">
                                <div class="ml-3">
                                    <h6 class="m-0 p-0 font-weight-bold">Multiple Recipients</h6>
                                    <small class="m-0 p-0 text-muted">Payout to more than one member of the pool</small>
                                    
                                </div>
                            </label>
                        </div>

                        <div class="multiple-select-body ml-4 pl-3 my-3" :class="{ 'd-none': isSingle, '': isMultiple }">
                            <div class="col-lg-7 p-0">
                                
                                <multiselect 
                                    v-model="payout_recipients" 
                                    :options="payout_contributors" 
                                    :multiple="true"
                                    :custom-label="customLabel"
                                    :close-on-select="false" 
                                    :clear-on-select="false" 
                                    :preserve-search="true" 
                                    placeholder="Search for a recipient" 
                                    track-by="account"
                                    @remove="removeRecipient($event)"
                                    :taggable="true">

                                </multiselect>
                                <!-- <pre class="language-json">< code>{{ payout_recipients }}</code></pre> -->
                            </div>

                            <form @submit.prevent="payoutContribution()">
                                <div class="col-md-12 p-0">
                                    <h6 class="pt-5" v-if="payout_recipients.length">Recipients</h6>
                                    <div class="form-group mt-2">
                                        <div class="row mb-3" v-for="(recipient, index) in payout_recipients" :key="index">
                                            <div class="col-lg-3 col-md-6">
                                                <label for="" class="d-flex flex-column">
                                                    <p class="m-0">
                                                        <small class="mr-3">({{ index + 1 }})</small>
                                                        {{ recipient.account.profile.firstname}} {{ recipient.account.profile.lastname}}<br>  
                                                    </p>
                                                    <!-- <span class="text-muted small ml-4 pl-2 m-0">{{ recipient.account.phone }}</span> -->
                                                    
                                                </label>
                                            </div>

                                            <div class="col-lg-4 col-md-6">
                                                <input type="number" 
                                                    @input="calcPayout($event)" 
                                                    @keydown="disableInputOnWrongValue($event)"
                                                    @change="calcPayout($event)"
                                                    ref="payout_amount" 
                                                    class="form-control" 
                                                    placeholder="Enter Amount"
                                                    v-model.number="recipient.payout_amount"
                                                    required
                                                >
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div class="col-lg-7 p-0">
                                    <div class="" v-if="pool != null">
                                        <p class="small font-weight-bold">You have added a total of &#8358;{{ total_amount | moneyformat }}.</p>
                                    </div>
                                    <!-- <div class="float-right"></div> -->
                                    <div class="form-group" v-if="payout_recipients.length">
                                        <!-- <label class="col-lg-3 col-form-label form-control-label"></label> -->
                                        <div class="d-flex mt-4 w-100">
                                            <div class="d-none d-md-block ml-auto">
                                                <button type="submit" class="btn btn-custom-sm ml-auto">Payout</button>
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <div class="d-md-none d-sm-block">
                                                <button type="submit" class="btn btn-custom btn-block ml-auto">Payout</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    props: {
        pool: {},
        contributors: {}
    },
    components: {
        Multiselect
    },
    data() {
        return {
            pool_id: this.$route.params.pool_id,
            form: {
                payout_type: 'single'
            },
            payees: '',
            payout_recipients: [],
            total_amount: 0,
            singlePayoutSelected : false,
            selectedParticipant: '',
        }
    },
    computed: {
        loading_state() {
            return this.$store.state.loading_state;
        },
        isSingle() {
            if (this.form.payout_type == 'single') return true
        },
        isMultiple() {
            if (this.form.payout_type == 'multiple') return true
        },
        remainder() {
            return parseFloat(this.pool.contributed_amount) - parseFloat(this.total_amount)
        },
        oa_payout_info() {
            return this.$store.getters.oa_payout_info;
        },
        hasPayoutBeenInitiated() {
            return this.oa_payout_info == null ? false : true;
        }
    },
    created() {
        this.$store.dispatch('getOrgAutonomyInfo', this.pool_id);
    },
    methods: {
        async payoutContribution() {
            // multiple payouts
            if (this.form.payout_type == 'multiple') {
                
                if (this.total_amount > this.pool.contributed_amount) {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: 'You cannot pay out more than the contributed amount'
                    });

                    return false;
                }

                if (this.total_amount < this.pool.contributed_amount) {
                    let self = this;

                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: 'You must pay out the whole sum of '+ self.pool.contributed_amount
                    });

                    return false;
                }

                const payees = this.payout_recipients.map(recipient => {
                    return {
                        account_id: recipient.account_id,
                        amount: recipient.payout_amount
                    }
                })

                const data = { pool_id: this.pool_id, payees: payees };

                // let reset = this.payout_recipients.map(({payout_amount}) => payout_amount = 0)
                try {
                    const payout = await axios.post('pool/payout/process', data);
                    console.log(payout)

                    if (payout.status == 200 && payout.data.message.hasOwnProperty('payees')) {
                        alert('Your Payout request has been sent, Thanks for using moneypool');

                        this.$router.go(-1)
                    }

                } catch (error) {
                    console.log(error.response)
                }
                // more than one payee
            } else {
                // single payout
                let payees = [];

                payees.push({
                    account_id: this.payees,
                    amount: this.pool.contributed_amount
                });
                const data = { pool_id: this.pool_id, payees };

                try {
                    const payout_request = await axios.post('pool/payout/process', data)
                    
                    if (payout_request.status == 200 && payout_request.data.message.hasOwnProperty('payees')) {

                        alert('Your Payout request has been sent, Thanks for using moneypool');

                        this.$router.go(-1)
                    }
                } catch (error) {
                    console.log(error.response)
                }
            }
        },
        calcPayout(event, recipient) {

            let amount = this.payout_recipients.map(recipient => {
                if (! recipient.hasOwnProperty('payout_amount')) {
                    recipient.payout_amount = 0
                } else if (typeof recipient.payout_amount == 'string' ) {
                    return 0
                } else {
                    return recipient.payout_amount
                }
            })
            .reduce((sum, figure) => parseInt(sum) + parseInt(figure) )

            this.total_amount = amount;
        },
        customLabel(contributors) {

            const { firstname, lastname } = contributors.account.profile;

            return `${firstname} ${lastname}`
        },
        showSinglePayoutMessage(event) {

            this.selectedParticipant = event.target.value;

            this.singlePayoutSelected = true;
        },
        async payoutRequests() {
            try {
                const requests = await axios.post(`/pool/payout/user/${this.user.account_id}`);
                console.log(requests);
            } catch (error) {
                console.log(error.response);
            }
        }
    }

}
</script>

<style>

</style>